enum WeaponType {
  VOID,
  HASHBLADE = "HASHBLADE",
  BOOMERANG = "BOOMERANG",
  BLAST = "BLAST",
  ROCK = "ROCK",
  BUBBLE = "BUBBLE",
  MAGNET = "MAGNET",
  POWER = "POWER",
  FORK = "FORK",
  RANGE = "RANGE",
  COOLDOWN = "COOLDOWN",
  SPEED = "SPEED",
  DURATION = "DURATION",
  ARMOR = "ARMOR",
  MAXHEALTH = "MAXHEALTH",
  GROWTH = "GROWTH",
  MOVESPEED = "MOVESPEED",
  LUCK = "LUCK",
  STONEAURA = "STONEAURA",
}

export default WeaponType;
